import React, { useState, useEffect } from "react";
import Clientsidebar from "../components/Clientsidebar";
import Clientheader from "../components/Clientheader";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { toast } from "react-toastify";

function Referandearn() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const [clientEmail, setclientEmail] = useState("");
  const [referralName, setReferralName] = useState("");
  const [referralEmail, setReferralEmail] = useState("");
  const [referralPhone, setReferralPhone] = useState("");
  const [referrals, setReferrals] = useState([]);
  const [referMessage, setReferMessage] = useState("");

  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setclientEmail(decoded.email);
      } catch (error) {
        console.error("Invalid token");
      }
    }
  }, []);

  const fetchReferrals = async () => {
    try {
      const response = await axios.post(
        "https://api.easytaxexperts.com/clientfetchReferrals",
        {
          username: clientEmail,
        }
      );
      if (response.data.success) {
        setReferrals(response.data.referrals);
       

      } else {
        console.error("Error fetching referrals:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching referrals:", error);
    }
  };

  useEffect(() => {
    if (clientEmail) fetchReferrals();
  }, [clientEmail]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      referralName.trim() === "" ||
      referralEmail.trim() === "" ||
      referralPhone.trim() === "" ||
      referralPhone.length < 10
    ) {
      toast.error("Please fill in all fields correctly.");
      return;
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(referralEmail)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    const newReferral = {
      clientEmail,
      referralName,
      referralEmail,
      referralPhone,
      
      
    };

    try {
      const response = await axios.post(
        "https://api.easytaxexperts.com/submitReferral",
        newReferral
      );
      if (response.data.success) {
        setReferrals([...referrals, newReferral]);
        setReferMessage(`You referred ${referralName}`);
        toast.success(`You referred ${referralName}`);
        window.location.reload();
      } else {
        console.error("Error submitting referral:", response.data.message);
      }
    } catch (error) {
      console.error("Error submitting referral:", error);
    }

    setReferralName("");
    setReferralEmail("");
    setReferralPhone("");
  };

  return (
    <div className="client-grid-container">
      <Clientheader openSidebar={openSidebar} />
      <Clientsidebar
        openSidebarToggle={openSidebarToggle}
        openSidebar={openSidebar}
      />
      <main className="main-container mt-2">
        <div className="container">
          <h4>Referral Form</h4>
          <form onSubmit={handleSubmit}>
            <label htmlFor="referralName" className="mt-2">
              Referral Name:
            </label>
            <input
              type="text"
              id="referralName"
              value={referralName}
              className="form-control"
              onChange={(e) => setReferralName(e.target.value)}
              required
            />

            <label htmlFor="referralEmail" className="mt-2">
              Referral Email:
            </label>
            <input
              type="email"
              id="referralEmail"
              value={referralEmail}
              className="form-control"
              onChange={(e) => setReferralEmail(e.target.value)}
              required
            />

            <label htmlFor="referralPhone" className="mt-2">
              Referral Phone Number:
            </label>
            <input
              type="tel"
              id="referralPhone"
              value={referralPhone}
              className="form-control"
              onChange={(e) => setReferralPhone(e.target.value)}
              required
            />

            <button className="btn btn-primary my-3" type="submit">
              Submit Referral
            </button>
          </form>
          {referMessage && <p className="success-message">{referMessage}</p>}

          <h4>Your Referrals</h4>
          <div className="table-responsive mt-3">
            <table className="table table-bordered table-hover">
              <thead className="table-primary">
                <tr>
                  <th>S.No</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                </tr>
              </thead>
              <tbody>
                {referrals.map((referral, index) => (
                  <tr key={index}>
                    <td>{index+1}</td>
                    <td>{referral.name}</td>
                    <td>{referral.email}</td>
                    <td>{referral.phone}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Referandearn;
